// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"a35683c9792655110e80","303":"93b42230e7751259bb9d","495":"e70f838a1dbb27c7bc12"}[chunkId] + ".js";
};